<footer class="l-footer" #footerContainer [innerHTML]="footerContent">
</footer>
